export const TARGETS = {
  SETTINGS: 'settings',
  SCRAPER_HEALTH: 'scraperHealth',
  SERVER_ERROR: 'serverError'
};
